import "./InventoryChk.css";
import Tbl, { useRcdList } from "../../input_types/Tbl/Tbl";
import { getErrMsgs } from "../../axios_with_token";
import { useRcd, useTbl } from "../../axios_with_token";
import { useRef, useState } from "react";

import { useChkRawData, regUses, randomUUID } from "../../axios_with_token";
import { useDialog, useRcdEditDialog } from "../../input_types/Dialog/Dialog";
import { set } from "react-hook-form";


const combineInvChgs = function(
    chkRawRcds,
    invChgItemsTbl,
    startDateIn,
    entitiesTbl,
    deliveriesTbl,
    ordersTbl,
    receivesTbl,
    inventoryAdjustsTbl 
){
    // chkRawRcds = chkRawRcds || [];
    // rcds = rcds || [];
    const rcds = (invChgItemsTbl||{}).rcds||[];
    const startDate = startDateIn.constructor==String?(new Date(startDateIn)):startDateIn;

    const result = [...(chkRawRcds||[]), ...((rcds||[]).filter(rcd=>(new Date(rcd.date) >= startDate)))].filter(a=>a);
    return result;
}

function PdtStatusInvChgs({invChgsOfPdt, opts}){
    const flds = ['__id', 'date', 'for', 'forSn', 'forId', 'dir', 'posId', 'skidId', 'pdtId', 'buyerId', 'qty', 'qtyOrg', 'unit', 'editBtn'];
    
    const sum = {
        in: 0,
        out: 0,
        poses: {

        }
    };
    
    return <div>
        {
            (invChgsOfPdt||[]).length<=0?<div><span style={{color:"red"}}>no data</span></div>
            :<table className="table">
                <thead>
                    <tr>
                        <th>No.</th>
                        {flds.map(fld=>{
                            return <th key={`title-${fld}`}>{fld}</th>;
                        })}
                        <th>action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        invChgsOfPdt.map((rcd, idx)=>{
                            sum.poses[rcd.skidId] = sum.poses[rcd.skidId] || 0;
                            if(rcd.dir > 0){
                                sum.in += rcd.qtyPC;
                                sum.poses[rcd.skidId] += rcd.qtyPC;
                            }else{
                                sum.out += rcd.qtyPC;
                                sum.poses[rcd.skidId] -= rcd.qtyPC;
                            }
                            
                            return <InvChgRcd
                                key={rcd.__id}
                                idx={idx}
                                rcd={rcd}
                                opts={{...opts,
                                    flds
                                }}
                            ></InvChgRcd>;
                        })
                    }
                </tbody>
            </table>
        }
        <table className="table" style={{width:"auto"}}>
            <tbody>
                <tr><td>in</td><td>{sum.in} piece</td><td>{sum.in/12} dozen</td></tr>
                <tr><td>out</td><td>{sum.out} piece</td><td>{sum.out/12} dozen</td></tr>
                <tr><td>total</td><td>{sum.in - sum.out} piece</td><td>{(sum.in - sum.out)/12} dozen</td></tr>                
            </tbody>

        </table>
        <p>positions: </p>
            <table className="table" style={{width:"auto"}}>
                <tbody>
                    {Object.keys(sum.poses).map(skidId=>{
                        const pos = opts.posesTbl.rcdsById[opts.skidIdToPosId[skidId]] || {sn: 'unkown pos'};
                        return <tr key={skidId}>
                            <td>{pos.sn}</td>
                            <td>{sum.poses[skidId]}</td>
                        </tr>                      
                    })}
                </tbody>
            </table>
            {/* {Object.keys(sum.poses).filter(skidId=>sum.poses[skidId]).map(skidId=>{
            const pos = opts.posesTbl.rcdsById[opts.skidIdToPosId[skidId]];
            return `${pos.sn}: ${sum.poses[skidId]}`;
        }).join(', ')} */}
        
    </div>;
}

function PdtStatus({pdtId, opts}){
    opts = opts || {};
    // const {setTblName, setRcdId, openDialog: openEditDialog, Dialog:EditDialog} = useRcdEditDialog({
    //     tblName: 'inventoryChangeItems'
    // });
    const pdt = opts.pdtsTbl.rcdsById[pdtId] || {};
    const invChgsOfPdt = [];

    return <div className="p-3">
        {/* <EditDialog></EditDialog> */}
        <h5>{`[${pdt.sn}-${pdt.brandAbbr}]-${pdt.name}` || `product of id [${pdtId}] has no name!`}</h5>
        <p>product inventory according to inventory changes:</p>
        <PdtStatusInvChgs
            invChgsOfPdt={
                opts.invChgItemsTbl.rcds.filter(rcd=>(rcd.pdtId == pdtId))
            }
            opts={opts}
        ></PdtStatusInvChgs>
        <p>product inventory according to inventory changes and check raw data:</p>
        <PdtStatusInvChgs
            invChgsOfPdt={
                opts.combinedChkRawAndInvChgRcds.filter(rcd=>(rcd.pdtId == pdtId))
            }
            opts={opts}
        ></PdtStatusInvChgs>
    </div>;
}

function usePdtStatus({pdtId:pdtIdIn, opts}){
    const [pdtId, setPdtId] = useState();

    return {
        pdtId,
        setPdtId,
        PdtStatus: ({})=>{
            return <PdtStatus
                pdtId={pdtId}
                opts={opts}
            >test</PdtStatus>;
        }
    };
}

function SkidStatus({InvChgRcdsOnSkid, opts}){
    const {regUse, isReady, isLoading, hasError, getErrMsgs} = regUses();
    const {setTblName, setRcdId, openDialog: openEditDialog, Dialog:EditDialog} = useRcdEditDialog({
        tblName: 'inventoryChangeItems'
    })
    const {Dialog:PdtStatusDlg, openDialog:openPdtStatusDlg} = useDialog({});
    const {PdtStatus, setPdtId} = usePdtStatus({opts});

    const {data:pdtsTbl} = regUse(useTbl("pdts"));

    InvChgRcdsOnSkid.sort((rcd1,rcd2)=>((new Date(rcd1.date)) > (new Date(rcd2.date))));
    const flds = ['__id', 'date', 'for', 'forSn', 'forId', 'dir', 'pdtId', 'buyerId', 'qty', 'qtyOrg', 'unit', 'editBtn'];
    const pdtSum = {};
    return isReady()&&<div className="p-3">
            <EditDialog
            ></EditDialog>
            <PdtStatusDlg>
                <PdtStatus></PdtStatus>
            </PdtStatusDlg>

            {InvChgRcdsOnSkid.length<=0?<div><span style={{color:"red"}}>no data</span></div>:<div>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>No.</th>
                                {flds.map(fld=><th key={`title-${fld}`}>{fld}</th>)}
                                <th>action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                InvChgRcdsOnSkid.map((invChgInfo, idx)=>{
                                    pdtSum[invChgInfo.pdtId] = pdtSum[invChgInfo.pdtId] || {
                                        qtyPC: 0
                                    };
                                    pdtSum[invChgInfo.pdtId].qtyPC += (invChgInfo.dir<0?-1:1)*invChgInfo.qtyPC;
                                    return <InvChgRcd
                                        key={`${invChgInfo.__id || randomUUID()}`}
                                        idx={idx}
                                        rcd={invChgInfo}
                                        opts={{...opts,
                                            flds,
                                            processForSn: forSn=>{
                                                const idDefs = [
                                                    {
                                                        name: 'invChg',
                                                        tblName: 'inventoryChangeItems',
                                                        tbl: opts.invChgItemsTbl
                                                    },
                                                    {
                                                        name: 'dlv',
                                                        tblName: 'deliveries',
                                                        tbl:opts.deliveriesTbl
                                                    },
                                                    {
                                                        name: 'odr',
                                                        tblName: 'orders',
                                                        tbl: opts.ordersTbl
                                                    } 
                                                ]
                                                if(forSn){
                                                    return forSn.split(',').map((id, idx)=>{
                                                        return idx?<button type="button" className="btn btn-sm btn-primary m-1"
                                                            title={`${idDefs[idx].tblName}-${id}`}
                                                            onClick={evt=>{
                                                                console.log('set tbl:', idDefs[idx].tblName);
                                                                setTblName(idDefs[idx].tblName);
                                                                setRcdId(id);
                                                                openEditDialog();
                                                            }}
                                                        >{`${idDefs[idx].name}[${idDefs[idx].tbl.rcdsById[id].sn}]`}</button>:'';
                                                    })
                                                }else{
                                                    return;
                                                }
                                            },
                                            processPdtId: pdtId=>{
                                                const pdt = pdtsTbl.rcdsById[pdtId] || {sn: 'pdt not found!'};
                                                return <button type="button" className="btn btn-sm btn-primary m-1"
                                                    onClick={evt=>{
                                                        setPdtId(pdt.__id);
                                                        openPdtStatusDlg();
                                                    }}
                                                >
                                                    {`[${pdt.sn}-${pdt.brandAbbr}]-${pdt.name}`}
                                                </button>;
                                            },
                                            processBuyer: (buyerId, buyerName)=>{
                                                return <button type="button" className="btn btn-sm btn-primary m-1"
                                                    title={buyerName}
                                                    onClick={evt=>{
                                                        setTblName('entities');
                                                        setRcdId(buyerId);
                                                        openEditDialog();
                                                    }}
                                                >{buyerName}</button>;
                                            },
                                            editBtn: (rcdId)=>{
                                                return <button
                                                    className="btn btn-sm btn-primary"
                                                    type="button"
                                                    onClick={evt=>{
                                                        setTblName('inventoryChangeItems');
                                                        setRcdId(rcdId);
                                                        openEditDialog();
                                                    }}
                                                >edit</button>
                                            }
                                        }}
                                    ></InvChgRcd>;
                                })
                            }
                        </tbody>
                    </table>
                    <h5>product summary</h5>
                    <table className="table" style={{width:"auto"}}>
                        <thead>
                            <tr>
                                <td>No.</td>
                                <td>product</td>
                                <td>quantity(piece)</td>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(pdtSum).map((pdtId, idxPdtId)=>{
                                const pdt = pdtsTbl.rcdsById[pdtId] || {};
                                return <tr key={pdtId}>
                                    <td>{idxPdtId+1}</td>
                                    <td>{`[${pdt.sn}-${pdt.brandAbbr}]-${pdt.name}`}</td>
                                    <td>{pdtSum[pdtId].qtyPC}</td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                </div>
            }
    </div>;
}

function InvChgRcd({idx, rcd, opts}){
    const flds = opts.flds || ['__id', 'date', 'for', 'forSn', 'forId', 'dir', 'pdtId', 'buyerId', 'qty', 'qtyOrg', 'unit', 'editBtn'];
    return <tr key={rcd.__id}>
        <td key={'No.'}>{idx+1}.</td>
        {flds.map(fld=>{
            const fldFn = opts[`process${fld[0].toUpperCase()+fld.substr(1)}`];
            return <td
                key={fld}
            >{fldFn?fldFn(rcd[fld]):rcd[fld]}</td>
        })}
        {/* <td>{rcd.__id}</td>
        <td>{rcd.date}</td>
        <td>{rcd.for}</td>
        <td>{opts.processForSn?opts.processForSn(rcd.forSn):}</td>
        <td>{rcd.forId}</td>
        <td>{rcd.dir}</td>
        <td>{opts.processPdtId?opts.processPdtId(rcd.pdtId)}</td>
        <td>{rcd.buyerId&&opts.processBuyer(rcd.buyerId, rcd.buyerName)}</td>
        <td>{rcd.qty}</td>
        <td>{rcd.qtyOrg}</td>
        <td>{rcd.unit}</td> */}
        <td>{(opts.editBtn&&rcd.__id) && opts.editBtn(rcd.__id)}</td>
    </tr>;
}


function useCombinedChkRawAndInvChgRcds({}){
    const {regUse, isReady, isLoading, errors} = regUses();

    const {data: chkRawRcds} = regUse(useChkRawData());
    const {data: posesTbl} = regUse(useTbl('poses'));
    const {data: pdtsTbl} = regUse(useTbl('pdts'));
    const {data: invChgItemsTbl} = regUse(useTbl('inventoryChangeItems'));
    const {data: entitiesTbl} = regUse(useTbl('entities'));
    const {data: deliveriesTbl} = regUse(useTbl('deliveries'));
    const {data: ordersTbl} = regUse(useTbl('orders'));
    const {data: receivesTbl} = regUse(useTbl('receives'));
    const {data: inventoryAdjustsTbl} = regUse(useTbl('inventoryAdjusts'));

    return {
        data: combineInvChgs(
            chkRawRcds,
            invChgItemsTbl,
            '2024-10-10',
            entitiesTbl,
            deliveriesTbl,
            ordersTbl,
            receivesTbl,
            inventoryAdjustsTbl
        ),
        loading: isLoading(),
        error: errors
    };

}

export function PosChk({posId, opts:optsIn}){
    const opts={...(optsIn||{})}
    const {regUse, isLoading, hasError, getErrorMsgs} = regUses();

    const [test, setTest] = useState();

    const {data:posGot} = regUse(useRcd('poses', posId));
    const pos = posGot || {};

    const {data:posesTbl} = regUse(useTbl("poses"));
    const {data:invChgItemsTbl} = regUse(useTbl("inventoryChangeItems"));
    const {data:combinedChkRawAndInvChgRcds} = regUse(useCombinedChkRawAndInvChgRcds({}))
    

    if (isLoading()) {
        return <div>Loading...</div>;
    }
    
    if(hasError()) {
        return <div>[RcdEditDialog] Error: {getErrMsgs().map(((errMsg, errMsgIdx)=><h3 key={`${errMsgIdx}`}>{errMsg}</h3>))}</div>;
    }    

    // console.log('refresh InventoryChk > env > pos', pos.__id);

    // products on the skids according to inventory change
    const skidId = (posesTbl.rcdsById[pos.__id] || {}).skidId;
    return <div>
        <h1>{pos.sn}</h1>
        <p>skid at the position: {skidId}</p>
        <hr></hr>
        <p>products on the skid:</p>
        <hr></hr>
        <p>according to inventory change:</p>
        <SkidStatus
            InvChgRcdsOnSkid={
                invChgItemsTbl.rcds.filter(rcd=>(rcd.skidId == skidId))
            }
            opts={opts}
        ></SkidStatus>

        <p>according to inventory change and check raw data:</p>
        <SkidStatus
            InvChgRcdsOnSkid={
                combinedChkRawAndInvChgRcds.filter(rcd=>(rcd.skidId == skidId))
            }
            opts={opts}
        ></SkidStatus>
        <button 
            type="button"
            className="btn btn-sm btn-primary"
            onClick={evt=>{
                setTest(randomUUID());
            }}
        >test</button>
    </div>;

}

export function Layout({opts}){
    const [chkRawDataStartDate, setChkRawDataStartDate] = useState(new Date('2024-10-10'));
    const forceRefresh = useState()[1];

    const {regUse, isLoading, hasError, getErrorMsgs} = regUses();

    const [posId, setPosId] = useState(0);
    
    const {
        component:PosList,
        invalidate:invalidatePosList
    } = regUse(useRcdList({
        tblName: 'poses',
        listFlds: 'sn',
        showIndex: true,
        btns:{
            edit: ({rcdId, cb})=><button type="button"
                className="btn btn-sm btn-primary"
                onClick={evt=>{
                    setPosId(rcdId);
                    // // evt.stopPropagation();
                    // setTblName(tblName);
                    // setRcdId(rcdId);
                    // openDialog();
                    cb&&cb();
                }}
            >check</button>
    }}));

    if (isLoading()) {
        return <div>Loading...</div>;
    }
    
    if(hasError()) {
        return <div>[RcdEditDialog] Error: {getErrMsgs().map(((errMsg, errMsgIdx)=><h3 key={`${errMsgIdx}`}>{errMsg}</h3>))}</div>;
    }    

    // console.log('refresh InventoryChk > layout')

    {   // [] preporcess data, put here for lighter refresh
        const {posesTbl, deliveriesTbl, ordersTbl, entitiesTbl, inventoryAdjustsTbl, receivesTbl} = opts;
      
        // [] prepare chkRawRcds

        const startDate = chkRawDataStartDate?(chkRawDataStartDate.constructor==String?chkRawDataStartDate:chkRawDataStartDate.toISOString().split('T')[0]):'2000-01-01'
        opts.chkRawRcds.forEach(rcd=>{
            rcd.date = startDate;

            rcd.qty = eval(rcd.qtyOrg || 0);
            rcd.qtyPC = rcd.qty;
            rcd.unit = 'PC';

            rcd.dir = rcd.dir || 1;
            rcd.posId = (posesTbl.rcds.find(rcdPos=>rcd.posSn == rcdPos.sn)||{id: undefined}).__id;
            rcd.skidId = (posesTbl.rcdsById[rcd.posId]||{sikdId: 'Pos not exists'}).skidId;
        });

        // [] prepare invChgItemsTbl
        opts.invChgItemsTbl.rcds.forEach(rcd=>{
            rcd.qty = eval(rcd.qtyOrg || 0);
            rcd.qtyPC = rcd.qty * (rcd.unit == 'DZ'? 12 : 1);
            rcd.dir = rcd.dir || 1;

            if(!rcd.dateOrg){
                if(rcd.for == 'deliveries'){
                    const dlv = deliveriesTbl.rcdsById[rcd.forId] || {};
                    rcd.dlvId = rcd.forId;
                    rcd.date = dlv.date || dlv.requestDate;
                    // rcd.forSn = [rcd.__id, `dlv[${rcd.forId}]`].join(',');
                    // rcd.forSn = dlv.sn || '[no delivery sn]';
                    rcd.forSn = [rcd.__id, rcd.forId].join(',');
                    rcd.note = [rcd.note,'use deliver date'].filter(a=>a).join(', ');

                    // const odr = ordersTbl.rcdsById[dlv.orderId] || {};
                    // // rcd.forSn +=  ` | ${odr.sn?odr.sn:'[no order sn]'}`;
                    // rcd.orderId = odr.__id;
                    // rcd.forSn = `${rcd.dlvId} [${[dlv.__id||'no deliver!', odr.__id||'no order!'].join(',')}]`;


                    // validate dlc
                    if(dlv.for){
                        rcd.note = [rcd.note,`dlv for (${dlv.for})`].filter(a=>a).join(', ');

                        if(dlv.for == 'orders'){
                            if(dlv.orderId){
                                // rcd.forSn = [rcd.forSn, `odr[${dlv.orderId}]`].join(',');
                                rcd.forSn = [rcd.forSn, dlv.orderId].join(',');
                                const order = ordersTbl.rcdsById[dlv.orderId] || {};
                                if(order.__id){
                                    const buyer = entitiesTbl.rcdsById[order.buyer] || {};
                                    rcd.orderSn = order.sn;
                                    rcd.orderId = order.__id;
                                    rcd.buyerId = order.buyer;
                                    rcd.buyerName = buyer.abbr || buyer.name;
                                }else{
                                    rcd.orderSn = 'get order error!';
                                    rcd.err = 1;
                                    rcd.note = [rcd.note,`dlv order not found.`].filter(a=>a).join(', ');
                                }
                            }else{
                                rcd.err = 1;
                                rcd.note = [rcd.note,`[dlv orderId empty]`].filter(a=>a).join(', ');
                            }                            
                        }
                    }else{
                        rcd.err = 1;
                        rcd.note = [rcd.note,`[dlv for empty]`].filter(a=>a).join(', ');
                    }
                }

                if(rcd.for == 'inventoryAdjusts'){
                    const invAdj = inventoryAdjustsTbl.rcdsById[rcd.forId] || {};
                    rcd.forSn = invAdj.sn;
                    rcd.date = invAdj.date;
                    rcd.note = [rcd.note,'adjust date'].filter(a=>a).join(', ');
                }
                if(rcd.for == 'receives'){
                    const rcv = receivesTbl.rcdsById[rcd.forId] || {};
                    rcd.forSn = rcv.sn;
                    rcd.date = rcv.date;
                    rcd.note = [rcd.note,'receive date'].filter(a=>a).join(', ');
                }

                if(!rcd.date){
                    rcd.date = '2023-01-01';
                    rcd.err = 1;
                    rcd.note = [rcd.note,`<span style="color:red;">date not defined<span>`].filter(a=>a).join(', ');
                }
            }
        });

        opts.skidIdToPosId = {};
        opts.posesTbl.rcds.forEach(rcd=>{
            opts.skidIdToPosId[rcd.skidId] = rcd.__id;
        })
    }

    return <div className="InventoryChk container">
        <div className="row">
            <h1>InventoryChk</h1>
            <div className="d-flex p-3">
                <button
                    type="button"
                    onClick={evt=>forceRefresh(randomUUID())}
                    className="btn btn-sm btn-primary me-3"
                >refresh</button>
                <input
                    type="date"
                    value={chkRawDataStartDate.toISOString().split('T')[0]}
                    onChange={evt=>{
                        const newDate = evt.target.value;
                        setChkRawDataStartDate(new Date(newDate));
                    }}
                />
            </div>

        </div>
        <div className="container">
            <div className="row">
                <div className="col-3" style={{overflow:"scroll"}}>
                    <PosList
                        opts={opts}
                    >
                    </PosList>
                </div>
                <div className="col-9">
                    <PosChk
                        opts={{...opts,
                            combinedChkRawAndInvChgRcds: combineInvChgs(
                                opts.chkRawRcds,
                                opts.invChgItemsTbl,
                                chkRawDataStartDate,
                                opts.entitiesTbl,
                                opts.deliveriesTbl,
                                opts.ordersTbl,
                                opts.receivesTbl,
                                opts.inventoryAdjustsTbl
                            )
                        }}
                        posId={posId}
                    ></PosChk>
                </div>
            </div>
        </div>
    </div>
}

export default function InventoryChk({}){
    const {regUse, isLoading, hasError, getErrorMsgs, DefaultError, DefaultLoading} = regUses();
    const refData = useRef({initd: false});

    const {data: chkRawRcds} = regUse(useChkRawData());
    const {data: posesTbl} = regUse(useTbl('poses'));
    const {data: pdtsTbl} = regUse(useTbl('pdts'));
    const {data: invChgItemsTbl} = regUse(useTbl('inventoryChangeItems'));
    const {data: entitiesTbl} = regUse(useTbl('entities'));
    const {data: deliveriesTbl} = regUse(useTbl('deliveries'));
    const {data: ordersTbl} = regUse(useTbl('orders'));
    const {data: receivesTbl} = regUse(useTbl('receives'));
    const {data: inventoryAdjustsTbl} = regUse(useTbl('inventoryAdjusts'));


    if (isLoading()) return <DefaultLoading></DefaultLoading>;
    
    if(hasError()) return <DefaultError></DefaultError>;
    
    // [fail] the following operations will be repeated
    // if(!refData.current.initd){
    //     refData.current.initd = true;

        // console.log('invChgItemsTbl, chkRawRcds:', invChgItemsTbl, chkRawRcds);
        // [] pre-process
        if(!chkRawRcds.initd){
            chkRawRcds.initd = true;
            chkRawRcds.forEach(rcd=>{
                rcd.qtyOrg = rcd.qty;
            });
        }

        if(!invChgItemsTbl.initd){
            invChgItemsTbl.initd = true;
            invChgItemsTbl.rcds.forEach(rcd=>{
                rcd.dateOrg = rcd.date;
                rcd.qtyOrg = rcd.qty;
            });
        }
    // }

    // console.log('refresh InventoryChk');
    return <div>
        <Layout
            opts = {{
                chkRawRcds,
                posesTbl,
                pdtsTbl,
                invChgItemsTbl,
                entitiesTbl,
                deliveriesTbl,
                ordersTbl,
                receivesTbl,
                inventoryAdjustsTbl
            }}
        >

        </Layout>
    </div>
}

